<template>
  <PageTemplate :title="metaTitle" :noContainer="true">
    <v-container class="pt-6 pb-10 pb-md-13 pb-lg-16">
      <ProductFilter />

      <div class="mt-6">
        <LoadingWidget v-if="loading" />

        <template v-else>
          <template v-if="items.length">
            <v-row>
              <v-col
                cols="12"
                lg="6"
                v-for="(item, keyItems) in items"
                :key="keyItems"
              >
                <ProductCard v-bind="item"></ProductCard>
              </v-col>
            </v-row>

            <v-pagination
              class="mt-6"
              v-if="pagesLength > 1"
              v-model="page"
              :length="pagesLength"
              :total-visible="6"
              flat
            ></v-pagination>
          </template>

          <v-alert v-else type="info">
            {{ noContentText }}
          </v-alert>
        </template>
      </div>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ProductFilter from "../components/forms/ProductFilter.vue";
import ProductCard from "../components/cards/ProductCard.vue";
import { formatToURL } from "../utils/formatToURL";
import { productFilter } from "../utils/productFilter";

const _config = {
  mod: "products",
  path: "/produtos",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  title: "Produtos",
  loading: true,
  totalItems: 0,
  noContentText: "Nenhum produto adicionado até o momento",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title, text }) => ({
        img,
        title,
        text,
        to: `${_config.path}/${formatToURL(`${title}-${id}`)}`,
      }));
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _pagination.itemsPerPage);
    },
    page: {
      get() {
        const p = this.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.p = v;
        else delete query.p;

        this.$router.push({ path: `${this.$route.path}`, query });
      },
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        returnTotalItems: _pagination.returnTotalItems,
        itemsPerPage: _pagination.itemsPerPage,
      };

      if (this.page) params.page = this.page;
      if (this.query.c) params.category = this.query.c;
      if (this.query.sc) params.subcategory = this.query.sc;
      if (this.search) params.search = this.search;
      if (this.brandId) params.brand = this.brandId;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, data) => {
            if (_pagination.returnTotalItems) {
              this.totalItems = data.totalItems;
              state.list = data.list;
            } else state.list = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    PageTemplate,
    LoadingWidget,
    ProductFilter,
    ProductCard,
  },
  mixins: [productFilter],
};
</script>
